module.exports = __webpack_public_path__ + "img/liucheng_detail@2x.1941954d.png";